import type { InfoListItemProps } from "./types"
import { twMerge } from "tailwind-merge"
import { useId } from "react-aria"

export const InfoListItem = ({ title, children, className, ...rest }: InfoListItemProps) => {
  const labelId = useId()
  const descriptionId = useId()

  return (
    <li
      {...rest}
      className={twMerge("base-text-medium flex justify-between gap-x-1 p-3", className)}
      aria-labelledby={labelId}
      aria-describedby={descriptionId}
    >
      <div id={labelId} className="flex items-center justify-start font-medium">
        {title}
      </div>
      <div id={descriptionId} className="flex items-center justify-end text-right text-gray-400">
        {children}
      </div>
    </li>
  )
}
